import React, { useState } from "react";
import { SovosBox, SovosIconButton, SovosTypography } from "mosaic-react";
import { AutoAwesome } from "mosaic-react-icons";
import StagingAutoFixModal from "./StagingAutoFixModal";

const StagingSuggestionCell = ({
    displayValue,
    onAccept,
    onFinalizeAccept,
    onReject,
    suggestion = null,
}) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <>
            <SovosBox
                sx={{
                    alignItems: "center",
                    display: "flex",
                    gap: 1,
                    minWidth: 0,
                    width: "100%",
                }}
            >
                <SovosIconButton
                    aria-label="Open Sovi auto fix"
                    data-staging-suggestion-trigger="true"
                    onClick={(event) => {
                        event.stopPropagation();
                        setAnchorEl(event.currentTarget);
                    }}
                    size="small"
                >
                    <AutoAwesome sx={{ color: "secondary.main", fontSize: 18 }} />
                </SovosIconButton>
                <SovosTypography
                    noWrap
                    sx={{ flex: 1, minWidth: 0 }}
                    variant="body2"
                >
                    {displayValue ?? ""}
                </SovosTypography>
            </SovosBox>
            <StagingAutoFixModal
                anchorEl={anchorEl}
                onAccept={() => onAccept?.(suggestion)}
                onClose={handleClose}
                onFinalizeAccept={onFinalizeAccept}
                onReject={() => {
                    onReject?.(suggestion);
                    handleClose();
                }}
                open={open}
                suggestion={suggestion}
            />
        </>
    );
};

export default StagingSuggestionCell;
